import React, { ReactElement } from "react";
import { AkkoordverklaringHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import "./akkoordverklaring.scss";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";
import { Chapter } from "../../components/Chapter";

type AkkoordVerklaringProps = {
  akkoordverklaring: AkkoordverklaringHoofdstuk;
};

export const AkkoordverklaringChapter = ({
  akkoordverklaring,
}: AkkoordVerklaringProps): ReactElement => {
  return (
    <Chapter>
      {akkoordverklaring.titel && (
        <Heading
          text={`${akkoordverklaring.titel}`}
        ></Heading>
      )}

      {/* U verklaart */}
      {akkoordverklaring.paragrafen?.["p30701"] && (
        <Paragraph withMarkdown>
          {akkoordverklaring.paragrafen?.["p30701"]?.inhoud ?? ""}
        </Paragraph>
      )}

      {/* lijst verklaringen*/}
      {akkoordverklaring.paragrafen?.["p30702"] && (
        <Paragraph withMarkdown>
          {akkoordverklaring.paragrafen?.["p30702"]?.inhoud ?? ""}
        </Paragraph>
      )}

      {/* nazorg    */}
      {akkoordverklaring.paragrafen?.["p30703"] && (
        <Paragraph withMarkdown>
          {akkoordverklaring.paragrafen?.["p30703"]?.inhoud ?? ""}
        </Paragraph>
      )}

      {/* Signature blocks container with flexbox */}
      <div className="signature-container">
        {/* Handtekening aanvrager 1 */}
        {akkoordverklaring.paragrafen?.["p30704"] && (
          <div
            className={`voorblad-chapter__adviesnummer signature-block ${
              akkoordverklaring.hasAanvrager2 
                ? "signature-block--with-second-applicant" 
                : "signature-block--without-second-applicant"
            }`}
          >
            <p className="mb-0">Plaats:</p>
            <p className="mb-0">Datum:</p>
            <br />
            <br />
            <br />
            <p className="underline"></p>
            <p className="mb-0">
              {akkoordverklaring.paragrafen?.["p30704"]?.inhoud ?? ""}
            </p>
          </div>
        )}

        {/* Handtekening aanvrager 2 */}
        {akkoordverklaring.hasAanvrager2 &&
          akkoordverklaring.paragrafen?.["p30705"] && (
            <div
              className="voorblad-chapter__adviesnummer signature-block signature-block--with-second-applicant"
            >
              <p className="mb-0">Plaats:</p>
              <p className="mb-0">Datum:</p>
              <br />
              <br />
              <br />
              <p className="underline"></p>
              <p className="mb-0">
                {akkoordverklaring.paragrafen?.["p30705"]?.inhoud ?? ""}
              </p>
            </div>
          )}

        {/* Handtekening adviseur */}
        {akkoordverklaring.paragrafen?.["p30706"] && (
          <div
            className={`voorblad-chapter__adviesnummer signature-block signature-block--last ${
              akkoordverklaring.hasAanvrager2 
                ? "signature-block--with-second-applicant" 
                : "signature-block--without-second-applicant"
            }`}
          >
            <p className="mb-0">Plaats:</p>
            <p className="mb-0">Datum:</p>
            <br />
            <br />
            <br />
            <p className="underline"></p>
            <p className="mb-0">
              {akkoordverklaring.paragrafen?.["p30706"]?.inhoud ?? ""}
            </p>
          </div>
        )}
      </div>
      </Chapter>
  );
};
